import { createSearchSelector, filterEntitiesSimpleFieldByValues, makeGetAllEntities } from '@lls/utils'

const getPremiumResources = makeGetAllEntities('premiumResources')

export const searchPremiumResources = createSearchSelector(
  getPremiumResources,
  (_state, params) => params,
  (premiumResources, { bookIds }) => filterEntitiesSimpleFieldByValues('book', bookIds)(premiumResources)
)
